import { forwardRef } from 'react';

/** Derives up to two initials from a display name for the image-less fallback. */
function initialsOf(name) {
  if (!name) return '';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

/**
 * A user/entity avatar (spec §7.1): an image when `src` is given, otherwise
 * initials derived from `name`. Purely decorative when no `alt`/`name`
 * conveys meaning beyond a nearby text label — pass `alt` when the image
 * itself is the only identifying content.
 *
 * @param {object} props
 * @param {string} [props.src]
 * @param {string} [props.alt='']
 * @param {string} [props.name] - used for the initials fallback.
 * @param {'lg'} [props.size]
 * @param {'brand'} [props.tone]
 * @param {string} [props.className]
 */
export const Avatar = forwardRef(function Avatar({ src, alt = '', name, size, tone, className = '', ...rest }, ref) {
  return (
    <span ref={ref} className={`etch-avatar ${className}`.trim()} data-size={size} data-tone={tone} {...rest}>
      {src ? <img src={src} alt={alt} /> : <span aria-hidden={alt ? undefined : 'true'}>{initialsOf(name)}</span>}
    </span>
  );
});

export default Avatar;
